<div class="h-100" [routerLink]="['/enterprise']" style="cursor: pointer;">
    <!-- <slideshow class="img-fluid" (window:resize)="onResize($event)" [imageUrls]="imageUrlArray" [showArrows]="false"></slideshow> -->
    <img (window:resize)="onResize($event)" class="img-fluid" style="width: 100%; display: block;" src="{{img_str}}" height="auto">
</div>